import { SEATS } from '../../../shared/world/seats';
import type { ServerOf } from '../../../shared/protocol';
import { placePeer, setPeerMeet, setPeerPub, type Peer } from '../../3-store/core/peers';

// 회의의 몫: 앉은 자리·화면 공유·손들기 (meet 메시지). 자리 번호의 뜻은 shared/world/seats.ts
export function onMeet(m: ServerOf<'meet'>) { setPeerMeet(m.id, m.k, m.v); }
export function onPub(m: ServerOf<'pub'>) { setPeerPub(m.id, m.pub); }   // 서버 송출 공지(학교): 어느 트랙을 받을지

// 앉은 사람은 의자 위치·방향으로 놓는다: 자리 번호가 표에 없거나 지금 장소의 자리가 아니면 앉은 것으로 보지 않는다
export function seatPose(r: Peer): boolean {
  const s = r.seat >= 0 ? SEATS[r.seat] : undefined;
  if (!s || s.room !== r.room) return false;
  placePeer(r, s.x, s.y, s.face, 'sit');
  return true;
}
export const seatTaken = (peerList: Iterable<Peer>, seat: number) => { for (const r of peerList) if (r.seat === seat && r.room === SEATS[seat]?.room) return true; return false; };
